const angular = require('angular')

module.exports = angular.module('mw.login', [
  require('./login.directive'),
  require('./forbidden.directive'),
  require('./test-login.directive'),
]).name
